import { Button, Col, Form, notification, Switch, Row } from "antd"
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../../../app/store"
import { EditableList } from "../../../../../compnents/list/EditableList"
import { getFieldSettingList, saveFieldSettingList } from "../FieldSettingSlice"
import { unwrapResult } from "@reduxjs/toolkit"
import { selectEdition, selectTenantCategory } from "../../../../../app/applicationSlice"
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import {
  DndContext,
  DragEndEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'

const BLFeildMap = {
  'TYBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, order: 1, rid: 'chiefComplaint' },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, order: 2, rid: 'historyOfPresentIllness' },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, order: 3, rid: 'pastMedicalHistory' },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, order: 4, rid: 'allergen' },
    { key: 'medicalHistory', label: '病史（个人史、家族史、疫苗接种史、月经史、婚育史）', isRequired: false, isVisible: true, order: 5, rid: 'medicalHistory' },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, order: 6, rid: 'tgjc' },
    { key: 'eyeExamination', label: '眼科检查', isRequired: false, isVisible: false, order: 7, rid: 'eyeExamination' },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, order: 8, rid: 'inspectionCheck' },
    { key: 'disease', label: '疾病名称', isRequired: true, isVisible: true, order: 9, isNotModified: true, rid: 'disease' },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, order: 10, rid: 'treatmentConclusion' },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, order: 11, rid: 'relatedImages' },
  ],
  'ZYBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, order: 1, rid: 'chiefComplaint' },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, order: 2, rid: 'historyOfPresentIllness' },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, order: 3, rid: 'pastMedicalHistory' },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, order: 4, rid: 'allergen' },
    { key: 'medicalHistory', label: '病史（个人史、家族史、疫苗接种史、月经史、婚育史）', isRequired: false, isVisible: true, order: 5, rid: 'medicalHistory' },
    { key: 'tonguePicture', label: '舌象', isRequired: false, isVisible: true, order: 6, rid: 'tonguePicture' },
    { key: 'pulseCondition', label: '脉象', isRequired: false, isVisible: true, order: 7, rid: 'pulseCondition' },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, order: 8, rid: 'tgjc' },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, order: 9, rid: 'inspectionCheck' },
    { key: 'disease', label: '中医诊断', isRequired: true, isVisible: true, order: 10, isNotModified: true, rid: 'disease' },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, order: 11, rid: 'treatmentConclusion' },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, order: 12, rid: 'relatedImages' },
  ],
  'KQBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, order: 1, rid: 'chiefComplaint' },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, order: 2, rid: 'historyOfPresentIllness' },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, order: 3, rid: 'pastMedicalHistory' },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, order: 4, rid: 'allergen' },
    { key: 'medicalHistory', label: '病史（个人史、家族史、疫苗接种史、月经史、婚育史）', isRequired: false, isVisible: true, order: 5, rid: 'medicalHistory' },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, order: 6, rid: 'tgjc' },
    { key: 'stomatologyTooth', label: '口腔检查', isRequired: false, isVisible: true, order: 7, rid: 'stomatologyTooth' },
    { key: 'inspectionTooth', label: '辅助检查', isRequired: false, isVisible: true, order: 8, rid: 'inspectionTooth' },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, order: 9, rid: 'relatedImages' },
    { key: 'diseaseTooth', label: '口腔诊断', isRequired: true, isVisible: true, order: 10, isNotModified: true, rid: 'diseaseTooth' },
    { key: 'treatmentTooth', label: '治疗计划', isRequired: false, isVisible: true, order: 11, rid: 'treatmentTooth' },
    { key: 'disposeTooth', label: '处置', isRequired: false, isVisible: true, order: 12, rid: 'disposeTooth' },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, order: 13, rid: 'treatmentConclusion' },
  ],
  'MRBL': [
    { key: 'chiefComplaint', label: '主诉', isRequired: false, isVisible: true, order: 1, rid: 'chiefComplaint' },
    { key: 'historyOfPresentIllness', label: '现病史', isRequired: false, isVisible: true, order: 2, rid: 'historyOfPresentIllness' },
    { key: 'pastMedicalHistory', label: '既往史', isRequired: false, isVisible: true, order: 3, rid: 'pastMedicalHistory' },
    { key: 'allergen', label: '过敏史', isRequired: false, isVisible: true, order: 4, rid: 'allergen' },
    { key: 'medicalHistory', label: '病史（个人史、家族史、疫苗接种史、月经史、婚育史）', isRequired: false, isVisible: true, order: 5, rid: 'medicalHistory' },
    { key: 'tgjc', label: '体格检查', isRequired: false, isVisible: true, order: 6, rid: 'tgjc' },
    { key: 'inspectionCheck', label: '辅助检查', isRequired: false, isVisible: true, order: 7, rid: 'inspectionCheck' },
    { key: 'disease', label: '中医诊断', isRequired: true, isVisible: true, order: 8, isNotModified: true, rid: 'disease' },
    { key: 'treatmentConclusion', label: '治疗意见', isRequired: false, isVisible: true, order: 9, rid: 'treatmentConclusion' },
    { key: 'relatedImages', label: '相关影像', isRequired: false, isVisible: true, order: 10, rid: 'relatedImages' },
  ],
}

export const MedicalRecordSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const hisVersion = useSelector(selectEdition)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)

  const [selectedType, setSelectedType] = useState<string>(hisVersion == 1 ? 'KQBL' : 'TYBL')
  
  const [params, setParams] = useState<any>({
    functionType: 1,
    templateType: selectedType,
  })
  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })
  const tenantCategory = useSelector(selectTenantCategory)

  // 修复：重构拖拽行组件，确保透传所有属性
  const SortableRow = (props: any) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props['data-row-key'], // 绑定行的唯一ID（rid）
      data: {
        type: 'row',
        item: props.record, // 透传当前行数据
      },
    })

    // 拖拽时的样式优化
    const style: React.CSSProperties = {
      ...props.style,
      transform: CSS.Transform.toString(transform),
      transition,
      cursor: 'move',
      opacity: isDragging ? 0.8 : 1,
      zIndex: isDragging ? 9999 : 'inherit',
      backgroundColor: isDragging ? '#f5f7fa' : 'inherit',
    }

    return (
      <tr
        {...props}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
        id={props['data-row-key']} // 使用rid作为行ID
      />
    )
  }

  // 修复：拖拽传感器配置（增加激活延迟，避免误触）
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // 拖动5px才触发，减少误触
      },
    }),
  )

  // 修复：拖拽结束逻辑，正确更新page.items
  const onDragEnd = (event: DragEndEvent) => {
    const { active, over } = event
    if (!active || !over || active.id === over.id) return

    // 找到拖拽行和目标行的索引
    const activeIndex = page.items.findIndex((item: any) => item.rid === active.id)
    const overIndex = page.items.findIndex((item: any) => item.rid === over.id)

    if (activeIndex === -1 || overIndex === -1) return

    // 移动数组并更新order
    const newItems = arrayMove([...page.items], activeIndex, overIndex)
    const updatedItems = newItems.map((item, index) => ({
      ...item,
      order: index + 1, // 重新排序order字段
    }))
    // 更新page状态，触发列表重渲染
    setPage((prev: any) => ({
      ...prev,
      items: updatedItems,
    }))
  }

  useEffect(() => {
    if (props?.selectedTab !== 'A1') return
    getPage(selectedType)
  }, [props?.selectedTab])

  const getPage = (templateType: string) => {
    setTableLoading(true)
    dispatch(getFieldSettingList({
      functionType: 1,
      templateType: templateType || selectedType,
    }))
      .then(unwrapResult)
      .then((res) => {
        if (res.length === 0) {
          const feilds = BLFeildMap[templateType as keyof typeof BLFeildMap]
          setPage({
            total: feilds.length,
            items: feilds,
          })
          setTableLoading(false)
          return
        } else {
          // 从后端获取的字段数据
          const backendFields = res[0].fields

          // 获取默认字段定义，用于合并 isNotModified 属性
          const defaultFields = BLFeildMap[templateType as keyof typeof BLFeildMap]

          // 合并默认字段的属性，补充rid（关键：拖拽需要唯一ID）
          const mergedFields = backendFields?.map((field: any) => {
            const defaultField = defaultFields?.find((df: any) => df.key == field.key)
            return {
              ...field,
              key: defaultField?.key || field.key,
              rid: defaultField?.key ||field.key, // 补充rid字段，作为拖拽唯一ID
              isNotModified: defaultField?.isNotModified || false,
              isRequired: Boolean(field.isRequired),
              isVisible: Boolean(field.isVisible),
              order: field.order || 1,
            }
          })
          setPage({
            total: mergedFields?.length,
            items: mergedFields,
          })
          setTableLoading(false)
        }
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }

  return (
    <div style={{ height: '100%' }}>
      <div style={{ padding: '0 4px', flexShrink: 0 }}>
        {hisVersion == 1 ? <></> :
          <>
            <Button
              type={selectedType === 'TYBL' ? 'primary' : 'default'}
              onClick={() => {
                setSelectedType('TYBL')
                getPage('TYBL')
              }}
              style={{ marginRight: '8px' }}
            >
              通用病历
            </Button>
            <Button
              type={selectedType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL') ? 'primary' : 'default'}
              onClick={() => {
                setSelectedType(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
                getPage(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
              }}
              style={{ marginRight: '8px' }}
            >
              {tenantCategory == 16 ? '盲人病历' : '中医病历'}
            </Button>
          </>}
        <Button
          type={selectedType === 'KQBL' ? 'primary' : 'default'}
          onClick={() => {
            setSelectedType('KQBL')
            getPage('KQBL')
          }}
        >
          口腔病历
        </Button>
      </div>
      <div style={{ margin: '10px 0 6px 0' }}>注：列表支持上下拖动调整字段顺序</div>
      <div style={{
        height: 'calc(100% - 80px)',
        borderRadius: '8px',
      }}>
        <Form
          style={{ height: '100%' }}
          form={form}
          autoComplete='off'
          onFinish={() => {
            setButtonLoading(true)
            dispatch(
              saveFieldSettingList({
                configType: 1,
                functionType: 1,
                templateType: selectedType,
                fields: page.items,
              })
            )
              .then(unwrapResult)
              .then((val) => {
                notification.success({
                  message: '设置成功',
                })
                form.resetFields()
                getPage(selectedType)
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div style={{ height: 'calc(100% - 50px)',paddingBottom:'20px', overflowY: 'auto' }}>
            <Row>
              <Col span={18}>
                {/* 修复：DndContext的onDragEnd直接绑定，无需透传参数 */}
                <DndContext
                  sensors={sensors}
                  modifiers={[restrictToVerticalAxis]}
                  onDragEnd={onDragEnd}
                >
                  {/* 修复：SortableContext的items使用page.items的rid数组 */}
                  <SortableContext
                    items={page.items.map((i: any) => i.rid)}
                    strategy={verticalListSortingStrategy}
                  >
                    <EditableList
                      components={{
                        body: {
                          row: SortableRow, // 使用修复后的拖拽行组件
                        },
                      }}
                      loading={tableLoading}
                      rowKey={(record: any) => record.rid} // 确保rowKey和拖拽ID一致
                      dataSource={page.items} // 替换page属性为标准dataSource（适配antd Table）
                      bordered={true}
                      pagination={false}
                      columns={[
                        {
                          title: '序号',
                          key: 'no',
                          align: 'center',
                          width: '5rem',
                          render: (_1, _2, i) => `${i + 1}`,
                        },
                        {
                          title: '病历字段',
                          dataIndex: "label",
                          key: "label",
                          align: "left",
                          width: '24rem',
                        },
                        {
                          title: '是否必填',
                          dataIndex: "isRequired",
                          key: "isRequired",
                          align: "center",
                          width: '12rem',
                          render: function action(_, t, index) {
                            return (
                              <Switch
                                checkedChildren='开启'
                                unCheckedChildren='关闭'
                                checked={t.isRequired}
                                disabled={t.isNotModified} // 如果isNotModified为true，则禁用开关
                                onChange={(checked) => {
                                  // 如果isNotModified为true，则不允许修改
                                  if (t.isNotModified) {
                                    return
                                  }
                                  const newItems = [...page.items]
                                  // 如果开启必填项，则自动开启展示项
                                  const newIsVisible = checked ? true : t.isVisible
                                  newItems[index] = {
                                    ...newItems[index],
                                    isRequired: checked,
                                    isVisible: newIsVisible
                                  }
                                  setPage({ ...page, items: newItems })
                                }}
                              />
                            )
                          },
                        },
                        {
                          title: '是否展示',
                          key: 'isVisible',
                          dataIndex: "isVisible",
                          align: 'center',
                          width: '12rem',
                          render: function action(_, t, index) {
                            return (
                              <Switch
                                checkedChildren='开启'
                                unCheckedChildren='关闭'
                                checked={t.isVisible}
                                disabled={t.isRequired || t.isNotModified} // 当必填项开启或isNotModified为true时禁用展示项
                                onChange={(checked) => {
                                  // 如果必填项已开启或isNotModified为true，则不允许修改
                                  if (t.isRequired || t.isNotModified) {
                                    return
                                  }
                                  const newItems = [...page.items]
                                  newItems[index] = { ...newItems[index], isVisible: checked }
                                  setPage({ ...page, items: newItems })
                                }}
                              />
                            )
                          },
                        },
                      ]}
                    />
                  </SortableContext>
                </DndContext>
              </Col>
            </Row>
          </div>
          <Row>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => getPage(selectedType)}
                style={{ float: 'right', marginRight: '10px' }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{ float: 'left' }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}